import Image, { type ImageProps } from 'next/image';

import topoPatternImage from '@commons/assets/textures/topo-pattern.png';

// Type definition for the TopoPattern component.

type Props = Partial<ImageProps> & {
  alt: string;
};

/**
 * TopoPattern component.
 */

const TopoPattern = ({ alt, ...props }: Props) => (
  <Image src={topoPatternImage} alt={alt} {...props} />
);

export default TopoPattern;
